import { discountSettingsSchema } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { TrackingPageDiscountSource } from "@redotech/redo-discounts-common/generated-discount-code-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const generateDiscountCode = {
  name: "generateDiscountCode" as const,
  input: z.object({
    discountId: zExt.objectId(),
    orderId: z.string().optional(),
    isPreview: z.boolean().optional(),
    source: createEnum(TrackingPageDiscountSource),
  }),
  output: z.object({
    discountCode: z.string(),
    discountSettings: discountSettingsSchema.optional(),
  }),
};
